import { logError } from '@core/logging';
function cookieDomain(domain) {
    if (domain) {
        return `;domain=.${domain}`;
    }
    return '';
}
const Cookies = {
    get: ({ name }) => {
        try {
            const nm = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(nm) === 0) {
                    return c.substring(nm.length, c.length);
                }
            }
            return;
        }
        catch (err) {
            logError(err);
        }
    },
    set: ({ name, value, domain, expirationDate, }) => {
        try {
            if (expirationDate) {
                document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()};path=/${cookieDomain(domain)}`;
            }
            else {
                document.cookie = `${name}=${value};path=/${cookieDomain(domain)}`;
            }
        }
        catch (err) {
            logError(err);
        }
    },
    remove: ({ name, domain }) => {
        try {
            document.cookie = `${name}=;max-age=0;path=/${cookieDomain(domain)}`;
        }
        catch (err) {
            logError(err);
        }
    },
};
export default Cookies;
